import Stack from 'react-bootstrap/Stack'

import { ApplePassButton } from '../../../QRTicketCard/ApplePassButton'
import { GooglePassButton } from '../../../QRTicketCard/GooglePassButton'
import { supportsWalletPass } from '../../../../utilities/walletDevice'

const ticketLabel = (ticket) => {
  if (ticket?.generalAdmission) {
    return ticket?.sectionNumber || 'General admission'
  }
  return `Sec ${ticket?.sectionNumber} · Row ${ticket?.rowNumber} · Seat ${ticket?.seatNumber}`
}

/**
 * Wallet passes for a guest order. Each ticket is its own pass, so a
 * multi-ticket order gets a labelled button row per ticket rather than one
 * button that would silently add only the first.
 */
export default function GuestWalletPasses({ event, tickets }) {
  // Without a checkInCode there is nothing to encode in the pass barcode.
  const passTickets = (tickets || []).filter((ticket) => ticket?.checkInCode)

  if (!event || !passTickets.length || !supportsWalletPass()) return null

  const showLabels = passTickets.length > 1

  return (
    <Stack gap={3} className="mt-3">
      {passTickets.map((ticket, index) => (
        <div key={ticket.uuid || ticket.id || index}>
          {showLabels && (
            <p className="caption text-muted mb-1">
              {`Ticket ${index + 1} of ${passTickets.length} · ${ticketLabel(
                ticket
              )}`}
            </p>
          )}
          <Stack direction="horizontal" gap={2} className="btn-group-flex">
            <ApplePassButton event={event} obj={ticket} />
            <GooglePassButton event={event} obj={ticket} />
          </Stack>
        </div>
      ))}
    </Stack>
  )
}
